import React, { useCallback, useEffect, useState } from 'react';
import PageContent from '../common/MainLayout/Page';
import { Stack } from '@mui/material';
import { useLazyQuery } from '@apollo/client';
import clientGraphql from '../../common/apollo-graphql';
import { ReferralProvider } from '../referral/context/ReferralContext';
import ManageReferralsTable from './table/ManageReferralsTable';
import { GET_REFERRALS } from '../referrals/gql';
import { isEmpty } from 'lodash';
import moment from 'moment';

function ViewManageReferralsTable({
  referralsData,
  loading,
  handleFilterFaxChanged,
  fromAppointmentAging
}) {
  return (
    <Stack direction="column" spacing={1}>
      <ManageReferralsTable
        data={referralsData}
        loading={loading}
        handleFilterFaxChanged={handleFilterFaxChanged}
        fromAppointmentAging={fromAppointmentAging}
      />
    </Stack>
  );
}

export default function ManageAppointmentAging({ history }) {
  const { id } = 1;

  const [filterFax, setFilterFax] = useState('all');
  const [referralsData, setReferralsData] = useState({});
  const [patientName, setPatientName] = useState('');
  const [type, setType] = useState('Name');
  const [birthdate, setBirthdate] = useState('');
  const referralStatus = ['scheduled', 'sent_fax'];

  const gqlParams = {
    client: clientGraphql,
    variables: {
      patientName: patientName,
      birthdate: birthdate,
      isFax: null,
      status: referralStatus
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  };

  const [getReferrals, { loading }] = useLazyQuery(GET_REFERRALS, gqlParams);

  const handleFilterFaxChanged = useCallback(
    e => {
      console.log(e.target.value);
      setFilterFax(e.target.value);
      if (e.target.value !== filterFax) {
        handleRefetch(e.target.value, patientName);
      }
    },
    [setFilterFax, handleRefetch, filterFax, patientName],
  );

  const handleRefetch = useCallback(
    (fax, name) => {
      console.log('handleRefetch');
      var variables = {
        patientName: !isEmpty(name) ? name : patientName,
        birthdate: birthdate,
        isFax: null,
        status: referralStatus,
      };
      if (!isEmpty(fax) && fax == 'fax') {
        variables.isFax = true;
      } else if (!isEmpty(fax) && fax == 'none') {
        variables.isFax = false;
      } else if (!isEmpty(fax) && fax == 'all') {
        variables.isFax = null;
      } else if (filterFax === 'fax') {
        variables.isFax = true;
      } else if (filterFax === 'none') {
        variables.isFax = false;
      }
    
      getReferrals({
        client: clientGraphql,
        variables: variables,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
      }).then(res => {
        const { data } = res;
        if (!isEmpty(data) && !isEmpty(data.rows)) {
          const filteredRows = data.rows.filter(item => {
            const hasPastAppointment = item.appointment?.appointment_date 
              && moment(item.appointment.appointment_date, 'YYYY-MM-DD').isBefore(moment().subtract(7, 'days'));
            
            return hasPastAppointment;
          });
          

          setReferralsData({
            rows: filteredRows.map(item => ({
              ...item,
              sent_at: moment(item.sent_at, 'YYYY-MM-DD HH:mm:ss').local(),
              updated_at: moment(item.updated_at, 'YYYY-MM-DD HH:mm:ss').local(),
              appointment_date: moment(item.appointment.appointment_date, 'YYYY-MM-DD HH:mm:ss').local()
            })),
            count: filteredRows.length,
          });
        }
      });
    },
    [getReferrals, birthdate, patientName, filterFax, referralStatus],
  );

  useEffect(() => {
    if (isEmpty(referralsData)) {
      setReferralsData({ rows: [], count: 0 });
      handleRefetch();
    }
  }, [referralsData, handleRefetch, setReferralsData]);

  return (
    <PageContent contentClass="manage-users">
      <ReferralProvider
        value={{
          id,
          handleRefetch,
        }}
      >
        {
          <ViewManageReferralsTable
            history={history}
            loading={loading}
            referralsData={referralsData}
            handleFilterFaxChanged={handleFilterFaxChanged}
            fromAppointmentAging={true}
          />
        }
      </ReferralProvider>
    </PageContent>
  );
}
